<template>
  <div class="assign-container">
    <el-card class="mt-4">
      <div>
        <span>工作号分配：{{ obj.phoneNumber }}</span>
      </div>

      <el-form :model="form" :rules="formRules" ref="formRef" label-width="120px" class="mt-4">
        <el-form-item>
          <el-tag>
            注意：已闲置的号卡,此处留空-不执行重复归还
          </el-tag>
        </el-form-item>
        <el-form-item label="分配给教练" prop="relationCoachId">
          <el-select v-model="form.relationCoachId" placeholder="请选择教练-留空则是归还"
                     clearable
                     filterable="true" remote="true"
                     :remote-method="fetchCoachList"
          >
            <el-option
                v-for="tCoach in coachList"
                :key="tCoach.coachid"
                :label="tCoach.coachname"
                :value="tCoach.coachid"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="日期" prop="assignDate">
          <el-date-picker
              v-model="form.assignDate"
              type="datetime"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="备注" prop="remarkNote">
          <el-input
              v-model="form.remarkNote"
              type="textarea"
              rows="4"
              placeholder="请填写原因或备注信息"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSubmit">提交分配</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 操作历史记录 -->
    <el-card class="mt-4">
      <div>
        <span>操作历史记录</span>
      </div>

      <el-table :data="assignmentHistory" border stripe>
        <el-table-column label="序号" type="index" width="60"/>
        <el-table-column label="所选时间" prop="assignDate" align="center"/>
        <el-table-column label="操作" prop="assignType" align="center">
          <template #default="scope">
            <el-tag :type="scope.row.assignType===1 ? 'success' :  'danger'">
              {{ scope.row.assignType===1?'分配':scope.row.assignType===2?'归还':scope.row.assignType===3?'修改实名':'' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="目标教练" prop="coachName" align="center"/>
        <el-table-column label="备注" prop="remarkNote" align="center"/>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import {assignPhone, getListCoachAll, loadAssignRecord} from "@/api/workphone";


export default {
  name: 'WorkPhoneAssign',
  props: {
    phoneId: String,
    obj: Object,
    arr: Array
  },
  data() {
    return {
      form: {
        phoneId: '',
        relationCoachId: '',
        remarkNote: '',
        assignDate: '',
      },//分配的表单
      formRules: {
        // relationCoachId: [{required: true, message: '请选择教练', trigger: 'change'}],
        assignDate:[{required: true, message: '请选择时间', trigger: 'change'}],
        remarkNote: [{ required: true, message: '请填写操作备注', trigger: 'blur' }]
      },//规则
      coachList: [], // 教练列表
      assignmentHistory: [], // 分配历史
    }
  },
  //dom后
  mounted() {
    //加载可分配的教练
    this.fetchCoachList("");
    //表单
    this.form.phoneId = this.phoneId

    if (this.form.phoneId) {
      this.handlePhoneChange(this.form.phoneId);
    }
  },
  //更新传入后
  updated() {
    // 如果从列表页带了phoneId参数过来，直接选中该工作号
    // const phoneId = this.$route.query.phoneId
//表单
    this.form.phoneId = this.phoneId

    if (this.form.phoneId) {
      this.handlePhoneChange(this.form.phoneId);
    }
  },
  methods: {

    // 获取教练列表
    fetchCoachList(inputCoachName) {
      getListCoachAll({
        keyword: inputCoachName || "", // 关键字参数
      }).then(res => {
        if (res.code === 200) {
          this.coachList = res.data
        } else {
          this.$message.error(`请求校区负责人失败！`);
        }
      })
    },

    // 工作号改变时获取其分配历史
    handlePhoneChange(phoneId) {
      if (!phoneId) return
      //临时参数
      let tempQuery = {
        phoneId
      };
      // 获取分配历史
      loadAssignRecord(tempQuery).then(res => {
        if (res.code === 200) {
          this.assignmentHistory = res.data.records
        }
      }).catch(err => {
        this.$message.error(err.message || '获取分配历史失败')
        this.assignmentHistory = [];
      })
    },

    // 提交分配
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          console.log(this.form);
          assignPhone(this.form).then(res => {
            if (res.code === 200) {
              this.$message.success('分配成功')
              this.handlePhoneChange(this.form.phoneId) // 刷新历史记录
              //调用父组件方法刷新
              this.$emit("parentReload");
            }
          }).catch(err => {
            this.$message.error(err.message || '分配失败')
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.assign-container {
  padding: 5px;
}

.mt-4 {
  font-size: large;
  font-weight: bold;
  margin: 15px;
}
</style>
